<template>
  <div class="pg-dialog-ocr-result">
    <div class="pg-dialog-ocr-result__title">{{ ocrType?.title }}</div>
    <template v-if="ocrType?.tabs?.length > 1">
      <div class="pg-dialog-ocr-result__title-tabs">
        <span
          class="pg-dialog-ocr-result__title-tabs-items"
          v-for="(tabItem, index) in ocrType.tabs"
          :key="index"
          :class="{
            'pg-dialog-ocr-result__title-tabs-items--active': tab?.title === tabItem.title,
          }"
          @click="swichTab(tabItem)"
          >{{ tabItem.title }}</span
        >
      </div>
    </template>
    <template v-if="tab?.key && tab?.children">
      <div class="pg-dialog-ocr-result__table-t">
        <div class="pg-dialog-ocr-result__table-header">
          <div
            class="pg-dialog-ocr-result__table-header-cell"
            v-for="item in tab.children"
            :key="item.key"
            :title="item.title"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="pg-dialog-ocr-result__table-body">
          <div
            class="pg-dialog-ocr-result__table-body-row"
            v-for="(dataItem, index) in getValueByPath(data, tab.key)"
            :key="index"
          >
            <PgInput
              class="pg-dialog-ocr-result__table-body-row-cell"
              v-for="item in tab.children"
              :key="item.key"
              :value="getValueByPath(dataItem, item.key)"
              @input="(val) => setValueByPath(dataItem, item.key, val)"
            />
          </div>
        </div>
      </div>
    </template>
    <div class="pg-dialog-ocr-result__table" v-else-if="tab?.children">
      <div class="pg-dialog-ocr-result__table-row" v-for="item in tab.children" :key="item.key">
        <div class="pg-dialog-ocr-result__table-row-l" :title="item.title">{{ item.title }}</div>
        <PgInput
          class="pg-dialog-ocr-result__table-row-r"
          :value="getValueByPath(data, item.key)"
          @input="(val) => setValueByPath(data, item.key, val)"
        />
      </div>
    </div>

    <PgInput v-else class="pg-dialog-ocr-result-input" type="textarea" v-model="data"></PgInput>
    <div class="pg-dialog-ocr-result__group">
      <span class="pg-dialog-ocr-result__group-icon" title="重置" @click="restore"
        ><i class="ivu-icon-icon-pg-cz"></i
      ></span>
      <span class="pg-dialog-ocr-result__group-icon" title="一键复制" @click="copy"
        ><i class="ivu-icon-icon-pg-yjfz"></i
      ></span>
      <span
        class="pg-dialog-ocr-result__group-icon-add"
        v-if="ocrAdd?.code && ocrAdd?.code === ocrType?.code"
        @click="add"
        >一键添加</span
      >
    </div>
  </div>
</template>
<script setup>
import { PgInput } from '../../input/index'
import { getValueByPath, setValueByPath, clone, copyMethod } from '../../../utils/index'
import { useOcrHelperInject } from '../hook/use-ocr'
import { ref, watch, shallowRef } from 'vue'

const props = defineProps({
  ocrData: [Object, String],
  ocrType: Object,
})

const tab = shallowRef(null)
watch(
  () => props.ocrType,
  () => {
    tab.value = props.ocrType?.tabs?.[0]
  }
)
const swichTab = (val) => {
  tab.value = val
}

const data = ref('')
watch(
  () => props.ocrData,
  () => {
    tab.value = props.ocrType?.tabs?.[0]
    data.value =
      props.ocrData && typeof props.ocrData === 'object' ? clone(props.ocrData) : props.ocrData
  }
)

const restore = () => {
  data.value =
    props.ocrData && typeof props.ocrData === 'object' ? clone(props.ocrData) : props.ocrData
}

const copy = () => {
  if (typeof data.value === 'string') {
    copyMethod(data.value)
  } else if (data.value && props.ocrType?.tabs) {
    let str = ''
    for (const tabItem of props.ocrType.tabs) {
      if (!tabItem.key) {
        str = tabItem.children.reduce((pre, cur) => {
          return pre + `${cur.title}: ${getValueByPath(data.value, cur.key)}\n`
        }, str)
      } else if (tabItem.key) {
        str = tabItem.children.reduce((pre, cur) => {
          return pre + `${cur.title}       `
        }, str)
        str = getValueByPath(data.value, tabItem.key).reduce((pre, cur) => {
          str = tabItem.children.reduce((tabPre, tabCur) => {
            return tabPre + `${getValueByPath(cur, tabCur.key)}       `
          }, `${pre}\n`)
          return str
        }, str)
      }
    }
    copyMethod(str)
  }
}

const ocrAdd = useOcrHelperInject()
const add = () => {
  ocrAdd.value?.fn(data.value)
}
</script>
<style lang="scss">
@import '../style/ocr-result.scss';
</style>
